export default {
  showConfirmDialog: false,
  confirmItem: null,
};
